'use strict';

var _regeneratorRuntime = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _defineProperty = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/defineProperty.js");

var _createClass = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _inherits = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _wrapNativeSuper = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var retry = require('retry');

var networkErrorMsgs = ['Failed to fetch', // Chrome
'NetworkError when attempting to fetch resource.', // Firefox
'The Internet connection appears to be offline.', // Safari
'Network request failed' // `cross-fetch`
];

var AbortError = /*#__PURE__*/function (_Error) {
  _inherits(AbortError, _Error);

  var _super = _createSuper(AbortError);

  function AbortError(message) {
    var _this;

    _classCallCheck(this, AbortError);

    _this = _super.call(this);

    if (message instanceof Error) {
      _this.originalError = message;
      var _message = message;
      message = _message.message;
    } else {
      _this.originalError = new Error(message);
      _this.originalError.stack = _this.stack;
    }

    _this.name = 'AbortError';
    _this.message = message;
    return _this;
  }

  return _createClass(AbortError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var decorateErrorWithCounts = function decorateErrorWithCounts(error, attemptNumber, options) {
  // Minus 1 from attemptNumber because the first attempt does not count as a retry
  var retriesLeft = options.retries - (attemptNumber - 1);
  error.attemptNumber = attemptNumber;
  error.retriesLeft = retriesLeft;
  return error;
};

var isNetworkError = function isNetworkError(errorMessage) {
  return networkErrorMsgs.includes(errorMessage);
};

var pRetry = function pRetry(input, options) {
  return new Promise(function (resolve, reject) {
    options = _objectSpread({
      onFailedAttempt: function onFailedAttempt() {},
      retries: 10
    }, options);
    var operation = retry.operation(options);
    operation.attempt( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(attemptNumber) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.t0 = resolve;
                _context.next = 4;
                return input(attemptNumber);

              case 4:
                _context.t1 = _context.sent;
                (0, _context.t0)(_context.t1);
                _context.next = 34;
                break;

              case 8:
                _context.prev = 8;
                _context.t2 = _context["catch"](0);

                if (_context.t2 instanceof Error) {
                  _context.next = 13;
                  break;
                }

                reject(new TypeError("Non-error was thrown: \"".concat(_context.t2, "\". You should only throw errors.")));
                return _context.abrupt("return");

              case 13:
                if (!(_context.t2 instanceof AbortError)) {
                  _context.next = 18;
                  break;
                }

                operation.stop();
                reject(_context.t2.originalError);
                _context.next = 34;
                break;

              case 18:
                if (!(_context.t2 instanceof TypeError && !isNetworkError(_context.t2.message))) {
                  _context.next = 23;
                  break;
                }

                operation.stop();
                reject(_context.t2);
                _context.next = 34;
                break;

              case 23:
                decorateErrorWithCounts(_context.t2, attemptNumber, options);
                _context.prev = 24;
                _context.next = 27;
                return options.onFailedAttempt(_context.t2);

              case 27:
                _context.next = 33;
                break;

              case 29:
                _context.prev = 29;
                _context.t3 = _context["catch"](24);
                reject(_context.t3);
                return _context.abrupt("return");

              case 33:
                if (!operation.retry(_context.t2)) {
                  reject(operation.mainError());
                }

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8], [24, 29]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  });
};

module.exports = pRetry; // TODO: remove this in the next major version

module.exports.default = pRetry;
module.exports.AbortError = AbortError;